import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { NoColorLink } from 'ui/NoColorLink';

type Props = {
    icon: React.ReactNode;
    text: string;
    onClick?: (arg1: React.SyntheticEvent<HTMLLIElement>) => void;
    className?: string;
    /** A link to an internal page, ex: explore */
    to?: string;
};

/**
 * An item with a icon and a label to be used in menu list.
 *
 */
const MenuHeaderItem = ({
    icon,
    text,
    onClick = () => {},
    className = '',
    to = '',
}: Props): React.ReactElement => {
    const item = (
        <MenuItem onClick={onClick} className={className}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </MenuItem>
    );
    if (to) {
        return <NoColorLink to={to}>{item}</NoColorLink>;
    }
    return item;
};
export { MenuHeaderItem };
